export default __webpack_public_path__ + "static/media/watches8.c2e9a15f.jfif";